export default "__VITE_ASSET__D$qsPAA3__"